import AppManagerClient from '../../api/AppManagerClient';
import { IManagingVirtualAppsInstance } from '../../api/models';
import React, { useEffect } from 'react';
import { VirtualAppsInfoView } from './VirtualAppsInfoView';
import { Merger } from '../../helpers/Merger';

export const VirtualAppsInfo = (props: any) => {
    const [serverApps, setServerApps]: [IManagingVirtualAppsInstance[], Function] = React.useState([]);
    const [isLoading, setLoadingStatus] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getVirtualAppsForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <VirtualAppsInfoView
            serverApps={Merger.merge(serverApps)}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isDataNotFound={serverApps.length === 0}
            applicationName={applicationName}
        />
    );
};
